// LEGACY: Pending approval page.
// This is no longer used now that we have open signup for influencers.
// The approval process has been removed.
//
// Pending Approval page for influencers
// Shows after signup completion while waiting for admin approval
// Prevents access to main dashboard until approved

import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext.jsx';

const InfluencerPendingApproval = ({ onNavigate }) => {
  const { user, profile } = useAuth();
  
  // LEGACY: If user reaches this page, redirect them to dashboard
  useEffect(() => {
    if (user) {
      onNavigate('dashboard');
    } else {
      onNavigate('login');
    }
  }, [user, onNavigate]);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-md p-8 text-center space-y-6">
          {/* Success Icon */}
          <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-blue-100">
            <span className="text-4xl">✅</span>
          </div>

          {/* Title */}
          <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Approval Process Removed
            </h1>
            <p className="text-gray-600">
              The approval process has been removed. If you reached this page, please return to your dashboard.
            </p>
          </div>

          {/* Actions */}
          <div className="space-y-3">
            <button
              onClick={() => onNavigate('dashboard')}
              className="w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
            >
              Go to Dashboard
            </button>
            <p className="text-xs text-gray-500">
              You now have immediate access to your dashboard and profile editor.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfluencerPendingApproval;

